import React from "react";
import QRCode from "react-qr-code";
import ACROSS_BANER_LOGO from "../../assets/images/AcrossLogo.png";
import { Box, Typography, Container, Paper } from "@mui/material";

const Scanner = () => {
  const apburl = "https://apb.acrossassist.com/";

  return (
    <Container maxWidth="sm" sx={Styles.ParentContainer}>
      <Box
        alt="Logo"
        component="img"
        sx={Styles.BannerLogo}
        src={ACROSS_BANER_LOGO}
      />

      <Typography variant="h5" gutterBottom sx={Styles.HeadingTxt}>
        🔒 Secure Policy Submission Made Easy
      </Typography>

      <Typography variant="body2" sx={Styles.DescriptionTxt}>
        Just scan the QR code, provide your details, record a quick video, and
        your policy will be safely saved.
      </Typography>

      <Paper elevation={3} sx={Styles.QRCodeContainer}>
        <QRCode value={apburl} size={200} style={Styles.QRCodeScannerImg} />
      </Paper>
    </Container>
  );
};

export default Scanner;

const Styles = {
  ParentContainer: {
    display: "flex",
    textAlign: "center",
    alignItems: "center",
    // minHeight: "100vh",
    flexDirection: "column",
    justifyContent: "center",
    mt: 10,
  },
  BannerLogo: { height: 50, mb: 3 },
  HeadingTxt: {
    fontWeight: "700",
    fontFamily: "Poppins, 'serif'",
    fontSize: { xs: "1.1rem", md: "1.2rem" },
  },
  DescriptionTxt: {
    mb: 4,
    fontWeight: "500",
    fontSize: { xs: "0.9rem", md: "1.1rem" },
    color: "text.secondary",
    fontFamily: "Poppins, 'serif'",
  },
  QRCodeContainer: { p: 3, borderRadius: 2 },
  QRCodeScannerImg: { height: "auto", maxWidth: "100%", width: "100%" },
};
